import React, { useContext, useEffect, useState } from "react";
import SocketContext from "../../../../context/SocketContext";

export default function High({ symbol_id }) {
  const socket = useContext(SocketContext);
  const [hight, setHigh] = useState(0);
  const [tickColor, setTickColor] = useState("text-[var(--subtext)]"); // default color

  useEffect(() => {
    if (!socket || !symbol_id) return;

    socket.emit("giverate", symbol_id);

    const tradeListener = (data) => {
      if (data && typeof data.High !== "undefined") {
        setHigh((prevLow) => {
          const newHigh = data.High;

          // compare new vs old to set tick color
          if (prevLow && newHigh > prevLow) {
            setTickColor("text-[var(--buymeta)]"); // up (green)
          } else if (prevLow && newHigh < prevLow) {
            setTickColor("text-[var(--sellmeta)]"); // down (red)
          }

          // reset back to default after 1s
          setTimeout(() => {
            setTickColor("text-[var(--subtext)]");
          }, 1000);

          return newHigh;
        });
      }
    };

    socket.on(`trade${symbol_id}`, tradeListener);

    return () => {
      socket.off(`trade${symbol_id}`, tradeListener);
    };
  }, [socket, symbol_id]);

  return (
    <span
      className={`text-center font-semibold  transition-all duration-300 font-medium ${tickColor}`}
    >
      H : {hight}
    </span>
  );
}
